import React, { useEffect } from 'react'
import ModalWindowStyle from './css/ModalWindowStyle'

function ModalWindow(props) {
  function ModalWindowHeader(props) {
    return (
      <div className='modal-window-header'>
        { props.children }
      </div>
    )
  }

  function ModalWindowContent(props) {
    return (
      <div id={`mwc-${props.id}`} className='modal-window-content'>
        { props.children }
      </div>
    )
  }

  function ModalWindowFooter(props) {
    return (
      <div id='modal-window-footer' className='modal-window-footer'>
        { props.children }
      </div>
    )
  }

  const onKeyUp = (e) => {
    if (e.key !== 'Tab') return
    const parent_window_id = `mwui-${props.id}`
    const bottom_anchor_id = `${props.id}-bottom-anchor`

    // find out the active element at the moment
    // When pressing [tab]
    if (e.target.id === `${props.id}-bottom-anchor`) {
      document.getElementById(parent_window_id).querySelector('.top-anchor').focus()
    }
    // When pressing [shift] + [tab]
    if (e.target.id === `${props.id}-top-anchor`)
      if (document.getElementById(bottom_anchor_id)) {
        const bottom_anchor = document.getElementById(parent_window_id).querySelector('.bottom-anchor')
        if (bottom_anchor) bottom_anchor.focus()
      }
      else document.getElementById(parent_window_id).querySelector('.top-anchor').focus()
  }

  useEffect(() => {
    const parent_window_id = `mwui-${props.id}`
    const top_anchor = document.getElementById(parent_window_id).querySelector('.top-anchor')
    if (top_anchor) top_anchor.focus()

    // Unmounting
    return(() => {
      // If this is a child window of a modal window
      if (props.id === 'mw-child')
        document.getElementById('modal-form-container').querySelector('.top-anchor').focus()
    })
  }, [props.id])

  return (
    <React.Fragment>
      <div className='modal-window-shadow'>
        <div id={`mwui-${props.id}`} onKeyUp={onKeyUp} className='modal-window-ui'>
          <div><a href='#top' id={`${props.id}-top-anchor`}>{null}</a></div>
          <ModalWindowHeader>{props.header}</ModalWindowHeader>
          <ModalWindowContent id={props.id}>{props.children}</ModalWindowContent>
          <ModalWindowFooter>{props.footer}</ModalWindowFooter>
          <ModalWindowStyle id={props.id} height={props.height} width={props.width}/>
          <div><a href='#bottom' id={`${props.id}-bottom-anchor`}>{null}</a></div>
        </div>
      </div>
      <div id={props.id}></div>
    </React.Fragment>
  )
}

// Usage Sample
/*
<ModalWindow
  width={50}
  height={60}
  id='mymessagebox'
  header={<div>Header</div>}
  footer={<div>Footer</div>}>
  { content }
</ModalWindow>
*/

export default React.memo(ModalWindow)
